import { render, staticRenderFns } from "./returnTheOrder.vue?vue&type=template&id=834bf9de&scoped=true&"
import script from "./returnTheOrder.vue?vue&type=script&lang=js&"
export * from "./returnTheOrder.vue?vue&type=script&lang=js&"
import style0 from "./returnTheOrder.vue?vue&type=style&index=0&id=834bf9de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834bf9de",
  null
  
)

export default component.exports